// src/pages/AdminLoginPage.js
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Lock, LogIn, AlertCircle } from 'lucide-react';
// Załóżmy, że masz jakiś podstawowy plik CSS dla admina lub używasz globalnych stylów formularza
// import './AdminPages.css'; // Opcjonalnie

function AdminLoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);
        try {
            const response = await axios.post(`${apiUrl}/api/auth/login`, { email, password });
            localStorage.setItem('adminToken', response.data.token);
            localStorage.setItem('adminUser', JSON.stringify(response.data.user)); // Opcjonalnie zapisz dane usera
            console.log("Login successful, token set.");
            navigate('/admin/dashboard');
        } catch (err) {
            console.error("Login failed:", err.response ? err.response.data : err.message);
            setError(err.response?.data?.errors?.[0]?.msg || 'Logowanie nie powiodło się. Sprawdź dane.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <section className="admin-login-page section-bg-light-gray" style={{ minHeight: 'calc(100vh - 150px)', display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: 'var(--header-height)'}}>
            <div className="container" style={{ maxWidth: '450px' }}>
                <div className="login-form-container" style={{ padding: '2rem', backgroundColor: 'var(--color-bg)', borderRadius: 'var(--border-radius)', boxShadow: '0 5px 15px rgba(0,0,0,0.1)' }}>
                    <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
                        <Lock size={48} color="var(--color-accent)" />
                        <h1 style={{ fontSize: '1.8rem', marginTop: '1rem', marginBottom: '0.5rem' }}>Panel Administratora</h1>
                        <p style={{ color: 'var(--color-text-light)', fontSize: '0.9rem' }}>Zaloguj się, aby kontynuować.</p>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="email">Adres E-mail</label>
                            <input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} required disabled={isLoading} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="password">Hasło</label>
                            <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} required disabled={isLoading} />
                        </div>
                        {error && (
                            <div className="submit-message error form-message" style={{ width: '100%', boxSizing: 'border-box', marginBottom: '1rem' }}>
                                <AlertCircle size={20}/> <span>{error}</span>
                            </div>
                        )}
                        <button type="submit" className="button-primary" disabled={isLoading} style={{ width: '100%' }}>
                            {isLoading ? 'Logowanie...' : <><LogIn size={18} style={{marginRight: '0.5rem'}} /> Zaloguj się</>}
                        </button>
                    </form>
                </div>
            </div>
        </section>
    );
}

export default AdminLoginPage;